import {ReactNode} from 'react';
import {SimpleForm} from 'react-admin';
import type {SxProps, Theme} from '@mui/material/styles';

interface AsideFormProps {
    children: ReactNode;
    /** Merged into the inner `SimpleForm` `sx` (width defaults to 100%). */
    sx?: SxProps<Theme>;
}

export const AsideForm = (props: AsideFormProps) => {
    const {children, sx} = props;

    return (
        <SimpleForm
            toolbar={false}
            sx={[
                {width: '100%', maxWidth: 440},
                ...(Array.isArray(sx) ? sx : sx != null ? [sx] : []),
            ]}
        >
            {children}
        </SimpleForm>
    );
};
